(function () {
    'use strict';

    angular.module("imApp").factory("coopService", ['$ihttp', function ($ihttp) {
        let service = {
            getCoop: function (parms) {
                return $ihttp.post({
                    method: 2728,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2729,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
